module.exports = __webpack_public_path__ + "img/app4.ba190a2a.png";